import { Component, Inject } from '@angular/core';
import module from 'app/modules/well-schematic-diagram/well-schematic-diagram.module';
import { WellSchematicApplicationService } from '../../services/well-schematic-application.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { HistoryRecordDetailsComponent } from '../history-record-details/history-record-details.component';

@Component({
  selector: 'app-well-barrier-status-historical-records',
  standalone: true,
  imports: module,
  templateUrl: './well-barrier-status-historical-records.component.html',
  styleUrl: './well-barrier-status-historical-records.component.scss'
})

export class WellBarrierStatusHistoricalRecordsComponent {
  searchForm: FormGroup;
  wellBarrierHistoricalRecords: any[] = []

  constructor(
    public dialogRef: MatDialogRef<WellBarrierStatusHistoricalRecordsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private service: WellSchematicApplicationService,
    private formBuilder: FormBuilder
  ) { }

  ngOnInit() {
    this.setForm()
    this.getHistoricalRecords()
  }

  setForm() {
    this.searchForm = this.formBuilder.group({
      Page: [0],
      PageSize: [999],
      OrderBy1: [null],
      OrderBy2: [null],
      OrderBy3: [null],
      OrderDir: 'asc',
      WellStringId: this.data.wellStringId
    });
  }

  getHistoricalRecords() {
    this.service.getMonitoringHistory(this.searchForm.getRawValue()).subscribe(res => {
      this.wellBarrierHistoricalRecords = res.data.data
    })
  }

  openHistoryRecordDetailsModal(historyRecordDetail) {
    const dialogRef = this.dialog.open(HistoryRecordDetailsComponent, {
        data: {
          wellLongName: this.data.wellLongName,
          historyRecordDetail: historyRecordDetail
        },
        width: "99%",
        maxWidth: "98%"
    });

    // dialogRef.afterClosed().subscribe(result => {
    //     console.log(`Dialog result: ${result}`);
    // });
}

  getStatusClass(value: string | null | undefined) {
    switch (value) {
      case 'Good':
        return 'successBadge';
      case 'Fail':
        return 'failedBadge';
      case 'Degraded':
        return 'warningBadge';
      default:
        return '';
    }
  }
}
